// Utils
import { createNamespace } from '../utils';
import { inherit } from '../utils/functional';
// Mixins
import { popupMixinProps } from '../mixins/popup';
// Components
import Popup from '../popup';
const [createComponent, bem] = createNamespace('notify');
function Notify(h, props, slots, ctx) {
    const style = {
        color: props.color,
        background: props.background,
    };
    return (<Popup value={props.value} style={style} position="top" overlay={false} duration={0.2} lockScroll={false} class={[bem([props.type]), props.className]} {...inherit(ctx, true)}>
      {slots.default?.() || props.message}
    </Popup>);
}
Notify.props = {
    ...popupMixinProps,
    color: String,
    message: [Number, String],
    duration: [Number, String],
    className: null,
    background: String,
    getContainer: [String, Function],
    type: {
        type: String,
        default: 'danger',
    },
};
export default createComponent(Notify);
